<div class="col s12 m12 l12 loan-card-section" *ngIf="(ongoingLoans && ongoingLoans.length > 0) || (pastLoans && pastLoans.length > 0)">
  <div class="tab-slider--nav valign-wrapper">
      <ul class="tab-slider--tabs">
          <li class="tab-slider--trigger" [class.active]="viewMode == 'Active'" rel="Active" (click)="viewMode ='Active'">Active Loans</li>
          <li class="tab-slider--trigger" [class.active]="viewMode == 'Past'" rel="Past" (click)="viewMode ='Past'">Past Loans</li>
      </ul>
  </div>
  <div class="tab-slider--container {{viewMode}}" [ngSwitch]="viewMode">
      <div id="Active" class="tab-slider--body" *ngSwitchCase="'Active'">
          <zest-loan-card [viewType]="viewMode" [Loan]="ongoingLoans" (hideCards)="hideLoanCard($event)" (triggerSMSLink)="triggerSMS()"></zest-loan-card>
      </div>
      <div id="Past" class="tab-slider--body" *ngSwitchCase="'Past'">
          <zest-loan-card [viewType]="viewMode" [Loan]="pastLoans" (hideCards)="hideLoanCard($event)"></zest-loan-card>
      </div>
  </div>
</div>
<div id="triggersmsModal" class="modal trigger-sms-modal" materialize="modal" [materializeParams]="[{dismissible: true}]">
  <div class="modal-content text-left">
      <div class="close-button" (click)="closeModal()">x</div>
      A message has been sent to you for making the repayment, please login to <a href="https://youraccount.zestmoney.in" target="_blank">youraccount.zestmoney.in</a> and pay your EMIs.
  </div>
</div>
